import { useState } from 'react';
import { Button } from '@hana/ui';
import s from './extra.module.css';

export interface MoreItem<K extends string> {
  key: K;
  label: string;
  n: number;
  /** err = đỏ · warn = cam (hot=2 / 1 của board) */
  hot?: 'warn' | 'err';
}

/** Nút "Thêm ▾" của Mint-Cost: menu các tab ngoài 4 tab chính; khi đang ở tab trong menu, nút hiện "<tên> · <số>". */
export function CostMore<K extends string>({ value, items, onPick }: { value: string; items: readonly MoreItem<K>[]; onPick: (k: K) => void }) {
  const [open, setOpen] = useState(false);
  const cur = items.find((x) => x.key === value);
  return (
    <span className={s.moreWrap}>
      <Button aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen(!open)}>
        {cur ? `${cur.label} · ${cur.n}` : 'Thêm'} ▾
      </Button>
      {open && (
        <div className={s.menu} role="menu" aria-label="Mục khác">
          {items.map((x) => (
            <button
              key={x.key}
              type="button"
              role="menuitemradio"
              aria-checked={value === x.key}
              className={s.item}
              onClick={() => {
                onPick(x.key);
                setOpen(false);
              }}
            >
              {x.label}
              <span className={`${s.n} ${x.hot ? s[`n_${x.hot}`] : ''}`}>{x.n}</span>
            </button>
          ))}
        </div>
      )}
    </span>
  );
}
